import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './SelectOption.scss';

/**
 * Helper component for react-select package allowing for custom rendering of options
 *
 * Example:
 *
 *  <Select
 *   ...
 *  components={{ Option: SelectOption }}
 * />
 *
 * @param {Object} props
 * @param {boolean} props.isDisabled - Whether the option is disabled
 * @param {Object} props.data - Data object passed to react-select
 * @param {string} props.data.label - Title of the option
 * @param {string} props.data.sublabel - Subtitle of the option
 * @param {string[]} props.data.sublabels - Array of subtitles of the option, each will be separated by a bullet
 */
const SelectOption = props => {
  const { data, isDisabled } = props;

  const sublabels = data.sublabel ? [data.sublabel] : data.sublabels || [];
  return (
    <div {...props.innerProps} className={cn('selection-option-outer-container', { disabled: isDisabled })}>
      <div className='title'>{data.label}</div>
      {!!sublabels.length && <div className='subtitle'>{sublabels.join(' • ')}</div>}
    </div>
  );
};

SelectOption.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    sublabel: PropTypes.string,
    sublabels: PropTypes.array
  }).isRequired
};

export default SelectOption;
